module.exports = __webpack_public_path__ + "media/components/src/assets/images/gallery_2-7881084b0ebf9cc1412924cdef0ff131.jpg";